// extracted by mini-css-extract-plugin
module.exports =  {"main":"DCZIRz","cart":"TjR9LY","summary":"mPEOfl","footer":"wSh6Nl"};